import React, { FC } from 'react'
import { getYear } from 'date-fns'
import { IconButton } from '@wmgtech/legato'
import { TRestrictedDatePickerProps } from '@wmgtech/legato/build/components/Datepicker/types'
import styles from './DateRangePicker.module.scss'

function range(from: number, to: number): number[] {
  const result = []
  for (let i = from; i < to; i++) {
    result.push(i)
  }
  return result
}

export const MonthPickerHeader: FC<TRestrictedDatePickerProps> = ({
  date,
  decreaseYear,
  increaseYear,
  changeYear,
  prevYearButtonDisabled,
  nextYearButtonDisabled,
}) => {
  const currentYear = getYear(date)
  const years = range(currentYear - 10, currentYear + 10)
  return (
    <div className={styles.header}>
      <IconButton
        className={styles.headerIcon}
        onClick={decreaseYear}
        disabled={prevYearButtonDisabled}
        message="arrow-left"
        icon="arrow-left"
      />
      <select
        className="lgt-calendar__period-type"
        value={currentYear}
        onChange={({target: {value}}) => changeYear(+value)}
      >
        {years.map(option => (
          <option key={option} value={option}>
            {option}
          </option>
        ))}
      </select>
      <IconButton
        className={styles.headerIcon}
        onClick={increaseYear}
        disabled={nextYearButtonDisabled}
        message="arrow-right"
        icon="arrow-right"
      />
    </div>
  )
}
